import { WHY_CHOOSE_CARS_LIST,WHY_CHOOSE_CARS_SUCCESS,WHY_CHOOSE_CARS_ERROR } from "../../../redux/contants";

import { all, fork, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios'
import { apiBaseUrl } from '../../../constants/defaultValues';

function* fetchWhyChooseCarAPI() {
    // alert('saga')
    try {
        // const subscriberDetails = yield Axios.get(`Role/GetRoleList`).then(response => response.data);
        // alert("c")
          const config = {
            method: 'get',
            url: `${apiBaseUrl}WhyChooseCar/GetWhyChooseCarList`,
            headers: { 
              'Accept': 'text/plain', 
              'Authorization': '<API Key>'
            }
          };
          const config_2 = {
            method: 'get',
            url: `${apiBaseUrl}OurValue/GetMaintitleList`,
            headers: { 
              'Accept': 'text/plain', 
              'Authorization': '<API Key>'
            }
          };
          const whychoosecardetails = yield axios(config).then(response => response.data.Data);
          const Maindetails = yield axios(config_2).then(response => response.data.Data);
          Maindetails.forEach(element => {
            if(element.Type === "WhyChooseCar")
            {
              //const obj = {Main_title_detail: element};
              whychoosecardetails.push(element);
            }
          });
        yield put({ type: WHY_CHOOSE_CARS_SUCCESS, data: whychoosecardetails });
    } catch (error) {
        yield put({ type: WHY_CHOOSE_CARS_ERROR, error });
    }
}


export function* watchWhyChooseCar() {
    // eslint-disable-next-line no-use-before-define
    yield takeEvery(WHY_CHOOSE_CARS_LIST, fetchWhyChooseCarAPI);

}

export default function* rootSaga() {
    yield all([
        fork(watchWhyChooseCar),
    ]);
}